export const Bio = {
  name: "Shubham Dharpure",
  roles: [
    "Frontend Developer",
    "React.js Developer",
    "UI/UX Designer",
    "Programmer",
  ],
  description:
    "I am a motivated and versatile individual, always eager to take on new challenges. With a passion for learning I am dedicated to delivering high-quality results. With a positive attitude and a growth mindset, I am ready to make a meaningful contribution and achieve great things.",
  github: "https://github.com/shubham2205",
  resume:
    "https://drive.google.com/file/d/1U3lhHLWPchMvo3rPXvQ3dH_ngrais8-I/view?usp=drivesdk",
  linkedin: "https://www.linkedin.com/in/shubhamdharpure22",
  twitter: "https://twitter.com/su_am_05",
  insta: "https://instagram.com/su_am05?igshid=MzMyNGUyNmU2YQ==",
  facebook: "https://www.facebook.com/shubham.dharpure.5",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
    
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "Tailwindcss",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/Tailwind_CSS_Logo.svg/640px-Tailwind_CSS_Logo.svg.png",
      },


      {
        name: "Framer motion",
        image:
          "https://i.ibb.co/M8t4mCz/framer-motion-logo-DA1-E33-CAA1-seeklogo-com.png",
      },
    
    ],
  },

];

export const experiences = [
  {
    id: 0,
    img: "https://i.ibb.co/5cKCjDB/umpteen-innovationn-cover.jpg",
    role: "Frontend Developer Intern",
    company: "Umpteen Innovation Bhopal",
    date: "June 2023 - Nov 2023",
    skills: [
      "HTMl",
      "CSS",
      "JavaScript",
      "Bootstrap",
      "TailwindCss",
      "React.js",
    ],
  },
 
];

export const education = [
  {
    id: 0,
    img: "https://scontent.fbho4-2.fna.fbcdn.net/v/t39.30808-6/277590872_383562197108194_7479920513659275288_n.png?_nc_cat=110&ccb=1-7&_nc_sid=a2f6c7&_nc_ohc=Z5pUfKE3hp4AX9abBPx&_nc_ht=scontent.fbho4-2.fna&oh=00_AfAmm0bBUlcDFQdWtQaE6BrazVxs95qMyBjHqqjETjBCqw&oe=651F8B7A",
    school: "NRI Institute of information Science and Technology",
    date: "Oct 2020 - Sep 2023",
    grade: "8.6 CGPA",
    desc: "I have  completed Bachelor's degree  at NRI Institute of information Science and Technology, Bhopal. ",
    degree: "Bachelor of Technology",
  },

  {
    id: 1,
    img: "https://svpc.mp.gov.in/images/header/19022018034441pcblogo.png",
    school: "Sardar Vallabhbhai Govt. Polytechnic College Bhopal",
    date: "2017 - 2020",
    grade: "6.7 CGPA",
    desc: "I have completed Diploma at Sardar Vallabhbhai Govt. Polytechnic College Bhopal",
    degree: "Polytechnic in Electrical Engineering",
  },

  {
    id: 2,
    img: "https://upload.wikimedia.org/wikipedia/en/thumb/d/d5/Board_of_Secondary_Education%2C_Madhya_Pradesh_logo.jpg/175px-Board_of_Secondary_Education%2C_Madhya_Pradesh_logo.jpg",
    school: "12th",
    date: "2016 - 2017",
    grade: "59.8%",
    desc: "I completed my class 12th in PCM at Saraswati Shishu Mandir Higher Secondary School, Pandhurna.",
    degree: "PCM",
  },

  {
    id: 3,
    img: "https://upload.wikimedia.org/wikipedia/en/thumb/d/d5/Board_of_Secondary_Education%2C_Madhya_Pradesh_logo.jpg/175px-Board_of_Secondary_Education%2C_Madhya_Pradesh_logo.jpg",
    school: "10th",
    date: "2015 - 2016",
    grade: "69.8%",
    desc: "I completed my class 10th at Govt. Rajendra Higher Secondary School, Kamthikala.",
    degree: "PCM",
  },
];

export const projects = [
  {
    id: 9,
    title: "Umpteen Innovation",
    date: "Jun 2023 - Nov 2023",
    description:
      "Umpteen Innovation is a web application of Umpteen Innovation Bhopal is a startup organisation, designed by me. It provides a user-friendly interface in this website user can see openings and know about the orgination",
    image: "https://i.ibb.co/3kz3wdT/Screenshot-2023-10-28-192200.png",
    tags: ["HTML", "CSS", "Javascript", "React", "GSAP", "Bootstrap", "Formik"],
    category: "web app",
    webapp: "https://umpteen-by-me.netlify.app/",
  },
  {
    id: 0,
    title: "Personal Portfolio Website",
    date: "Apr 2023 - May 2023",
    description:
      "A React-based portfolio website is a dynamic and responsive online platform designed to showcase work and creativity. It features an elegant and user-friendly interface, with customizable layouts and a modern aesthetic.",
    image: "https://i.ibb.co/BPq5Ncx/Screenshot-2023-10-29-082246.png",
    tags: ["React Js", "MongoDb", "Node Js", "Express Js", "Redux"],
    category: "web app",
    // github: "https://github.com/",
    webapp: "",
    member: [
      {
        name: "Shubham Dharpure",
        img: "https://media.licdn.com/media/AAYQAQSOAAgAAQAAAAAAAB-zrMZEDXI2T62PSuT6kpB6qg.png",
        linkedin: "https://www.linkedin.com/in/shubhamdharpure22/",
        github: "",
      },
    
    ],
  },
  {
    id: 1,
    title: "Shush !",
    date: "Oct 2022",
    description:
      "Designed and developed the Shush ! project, a project is explore high-quality hosting and domain services at competitive prices. With a user-friendly interface and a dedicated support team, we are here to help you bring your web projects to life.",
    image:
      "https://i.ibb.co/tscR4KZ/Screenshot-2023-10-31-083101.png",
    tags: [
     "HTML",
     "Css",
     "Js",
     "GSAP",
    ],
    category: "web app",
    // github: "https://shubham2205.github.io/Shush.github.io/",
    webapp: "https://shubham2205.github.io/Shush.github.io/",
  },
  {
    id: 2,
    title: "DOOB Event",
    date: "Jan 2022",
    description:
      "Static website create using HTML, CSS , Js and some animation of GSAP JavaScript animation library ",
    image:"https://i.ibb.co/pw8rfQn/Screenshot-2023-10-31-091715.png",
    tags: ["HTML", "CSS", "js", "GSAP"],
    category: "web app",
    webapp: "https://shubham2205.github.io/DOOB_Event/",
   
  },
 
];

export const TimeLineData = [

];
